/** Mise de sélection des noeuds de l'arborescence */
enum SelectModeEnum {
	/** Mono-sélection sans case à cocher */
	Single = 'Single',
	/** Multi-sélection avec coches et gestion des pins de différents types en inclus/exclus */
	MultiAdvanced = 'MultiAdvanced',
	/** Multi-sélection avec coches sans affichage de pins (mais géré en interne du FilterTree) et sans leader et sans inclus/exclus */
	MultiSimple = 'MultiSimple',
	/** Multi-sélection avec coches sans affichage de pins (mais géré en interne du FilterTree) et sans leader mais avec exclusion de noeud sur une même branche */
	MultiExcluded = 'MultiExcluded'
	// /** 
	//  * SingleMode sans sélection sauf pour les noeuds précisés sélectionnables et/ou cliquable via InitParameters
	//  * @todo A implémenter avec SLavina !!!
	//  */
	// ,Unselected = 4
}

export default SelectModeEnum;